import { render, staticRenderFns } from "./delete-multiple-rooms.vue?vue&type=template&id=4e5fce2c&scoped=true&"
import script from "./delete-multiple-rooms.vue?vue&type=script&lang=js&"
export * from "./delete-multiple-rooms.vue?vue&type=script&lang=js&"
import style0 from "./delete-multiple-rooms.vue?vue&type=style&index=0&id=4e5fce2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5fce2c",
  null
  
)

export default component.exports